import axios from 'axios';
import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './HomePage.css';
import NavBarShan from '../NavBar/NavBar';
import LoadingLoggedIn from '../Loading/Loading';

class HomePageDet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeClassName: 'far fa-times-circle',
      HomePageUrl: 'https://my-webpage-node.vercel.app/HomePage/',
      HomePageData: [],
      Loading: false,
      line1: 'Home Page',
      textAnimationLine1: [],
      editPopUp: false,
      editPopUpData: {},
      error: false,
      errorDetails: '',
      HomePageEditUrl: 'https://my-webpage-node.vercel.app/HomePage/EditDetails',
      ButtonClicked: false,
      ButtonText: 'Change'
    }
    this.ChangeBtnClick = this.ChangeBtnClick.bind(this)
  }

  async componentDidMount() {
    let tempArr1 = []
    this.props.SelectedPage('LoggedInPage', {
      SelectedPage: 0
    })
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
      editPopUpData: {}
    })
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.Loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    await axios.get(this.state.HomePageUrl).then((e) => {
      this.setState({
        HomePageData: e.data,
        Loading: true
      })
    }).catch((e) => {
      console.log(e);
      this.setState({
        Loading: false
      })
    })
  }

  async ChangeBtnClick() {
    if (!this.state.ButtonClicked) {
      if (this.state.editPopUpData?.role.length <= 30) {
        this.setState({
          ButtonClicked: true,
          ButtonText: 'In Progress'
        })
        await axios.post(this.state.HomePageEditUrl, this.state.editPopUpData).then((e) => {
          if (e?.data.toString() === 'Success') {
            this.setState({
              ButtonClicked: false
            })
            window.location.reload();
          } else {
            this.setState({
              error: true,
              errorDetails: e?.data,
              ButtonClicked: false,
              ButtonText: 'Change'
            })
          }
        }).catch((e) => {
          this.setState({
            error: true,
            ButtonClicked: false,
            ButtonText: 'Change'
          })
          console.log(e)
        })
      } else {
        this.setState({
          error: true,
          ButtonClicked: false,
          ButtonText: 'Change',
          errorDetails: 'Length Invalid Require less than 30 Character'
        })
      }
    }
  }

  render() {
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    return (<>
      <div className='LoggedInCommonDiv'>
        <NavBarShan />
        {this.state.Loading ?
          <div className='LoggedInSideDiv'>
            <div className='HomePageHeadingDiv'>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='AboutAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'AboutAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'AboutAniLetterMouse AboutAniLetter' : 'AboutAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
            <table className='HomePageLoggedInTbl'>
              <thead>
                <tr>
                  <th className='HomePagepd20 HomePageLoggedInTblBrd'>ID No</th>
                  <th className='HomePagepd20 HomePageLoggedInTblBrd'>Role Description</th>
                  <th className='HomePagepd20 HomePageLoggedInTblBrd'>Option</th>
                </tr>
              </thead>
              <tbody>
                {this.state.HomePageData.map((ite, index) => {
                  return (<>
                    <tr>
                      <td className='HomePagepd20 HomePageLoggedInTblBrd'>{ite?._id}</td>
                      <td className='HomePagepd20 HomePageLoggedInTblBrd'>{ite?.role}</td>
                      <td className='HomePagepd20 HomePageEditBtn HomePageLoggedInTblBrd' onClick={() => {
                        this.setState({
                          editPopUpData: ite,
                          editPopUp: true
                        })
                      }}>Edit</td>
                    </tr>
                  </>)
                })}
              </tbody>
            </table>
          </div> :
          <LoadingLoggedIn />}
        {this.state.editPopUp ?
          <div className='HomePageEditDataPopUpLoggedIn'>
            <div className='HmPgSubDvLgIn'>
              <div className='HmPgSubLgInFstDv'>
                <div className='popUpDivisionHeading'>
                  {this.state.editPopUpData?._id}
                </div>
                <i className={this.state.closeClassName + ' popUpCloseWindow'} onMouseEnter={() => {
                  this.setState({
                    closeClassName: 'fas fa-times-circle'
                  })
                }} onMouseLeave={() => {
                  this.setState({
                    closeClassName: 'far fa-times-circle'
                  })
                }} onClick={() => {
                  this.setState({
                    closeClassName: 'far fa-times-circle',
                    editPopUp: false
                  })
                }}></i>
              </div>
              <div className='LoginHomePagePopUpDiv1'>
                <div>
                  <div className='LoginHomePagePopUpHeadDiv'>ID :</div>
                  <div className='LoginHomePagePopUpContentDiv'>{this.state.editPopUpData?._id}</div>
                </div>
                <div>
                  <div className='LoginHomePagePopUpHeadDiv'>Role :</div>
                  <input className='LoginHomePagePopUpEditContentDiv' value={this.state.editPopUpData?.role} onChange={(e) => {
                    let data = { ...this.state?.editPopUpData, role: e.target.value }
                    this.setState({
                      editPopUpData: data,
                      error: false,
                      errorDetails: ''
                    })
                  }} />
                </div>
                <div className='LoginHomePagePopUpBtnWrapper'>
                  {this.state.error ? <div className='LoginHomePagePopUpBtnDiv1'>{this.state.errorDetails}</div>
                    : ''}
                  <div className='LoginHomePagePopUpBtnDiv2' onClick={(e) => {
                    this.ChangeBtnClick()
                  }}>{this.state.ButtonText}</div>
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>

    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePageDet));